import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import {
    GetMembershipStatus,
    GetMembershipStatusResponse,
} from '../api/dtos';
import useRegistrationYear from './useRegistrationYear';

const getData = (response?: SWRResponse<GetMembershipStatusResponse, GetMembershipStatusResponse>) => response?.data?.type;

const getError = (response?: SWRResponse<GetMembershipStatusResponse, GetMembershipStatusResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetMembershipStatusResponse, GetMembershipStatusResponse>) => ({
    membershipType: response?.data?.type,
    registered: response?.data?.registered
});

export const useMembershipStatus = (firstName?: string, lastName?: string, configuration?: SWRConfiguration) => {
    const registrationYear = useRegistrationYear();

    const membershipRequest = useMemo(() => {
        if (!firstName || !lastName) {
            return undefined;
        }

        return () => {
            return new GetMembershipStatus({firstName, lastName, registrationYear});
        };
    }, [firstName, lastName, registrationYear]);

    return useGet(membershipRequest, { getData, getError, getAdditionalState }, configuration);
};

export default useMembershipStatus;